var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _use, _use2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBluetooth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 347 85.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M87.2 45.6c10.4-.488 11.5 2.93 11.6 9 0 6.02-1.45 9.5-11.5 9v-18zm0-24.1c8.94-.408 10.3 2.6 10.4 8.3 0 7.5-4.73 7.5-10.5 7.5V21.5zM77.1 72h16c11.5 0 15.8-7.3 15.8-17 0-7.6-3-11.6-8.1-13.9 4.9-2 7-7.2 7-12.3 0-10-4.8-15.5-15.6-15.5h-15V72z",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M122 72V13.2h-9.1V72zm24-43.8v34.3c-2.1 1.5-3.9 2.8-5.9 2.8s-3.3-1-3.3-3.2V28.2h-9.1v35.4c0 5.7 2.8 9.2 7.6 9.2 5.3 0 7.2-2 11.1-5.2V72h8.6V28.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M170 44.3c0-4.33-.06-9.36 5-9.5 5.34 0 5 5.22 5 9.5zm19.3-.7c0-9.6-3.7-16.3-14.2-16.3-10.4 0-14.2 6.7-14.2 16.3v12.9c0 9.6 3.7 16.3 14.2 16.3 10.2 0 14-6.3 14.2-15.6h-9.1c-.09 4.1-.144 8.2-5 8.2-3.3 0-5-2.1-5-7.2v-6.3h19.2v-8.3z",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "m346.9 19.5c0 3.5-3 6.4-6.4 6.4-3.6 0-6.4-2.8-6.4-6.4 0-3.5 2.9-6.4 6.4-6.4 3.6 0 6.4 2.8 6.4 6.4zm-11.5-.1c0 2.7 2.2 5.1 5 5.1s5-2.3 5-5c0-2.8-2.2-5.1-5-5.1-2.7 0-5 2.3-5 5zm6.2 3.6-2-3.1h-.1v3.1h-1.2v-7.1h2.1c1.7 0 2.4.7 2.4 1.8 0 1.2-.7 1.9-1.9 2 .2.2.4.6.7 1l1.5 2.2h-1.5zm-1.2-6.1h-.8v2.2h.5c1.1 0 1.5-.6 1.5-1.2 0-.7-.4-1-1.2-1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    id: "A",
    d: "M197 35.7V63c0 6.7 3.8 9.8 10.7 9.8 2.3 0 3.3-.2 4.6-.5v-7.8h-3c-2.1 0-3.1-1.3-3.1-3.6V35.7h6.1v-7.5h-6.1V16.4h-9.1v11.8h-5v7.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    id: "B",
    d: "M236 58.1c0 5-1.8 7.2-5 7.2-3.3 0-5-2.1-5-7.2V42c0-11.2 10.8-8.94 10 0zm-19.2-1.6c0 9.6 3.7 16.3 14.2 16.3 10.4 0 14.2-6.7 14.2-16.3V43.6c0-9.6-3.7-16.3-14.2-16.3-10.4 0-14.2 6.7-14.2 16.3z",
    fillRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M316 72V37.6c2.86-2.6 9.2-5.12 9.2.4v34h9.1V36.6c-.904-13.3-12.1-10.6-18.2-4.3v-19H307V72z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8 21l7 7-7 7zm0 43.1l7-7-7-7zm-7.5-21.5L12.1 27.3l4.4-4.4L28.6 35V6l22 22-14.5 14.6 14.6 14.6-22 22V50.1L16.5 62.2l-4.4-4.4zm4.1 42.5c18.6 0 31.4-8.8 31.4-42.6C62.8 8.8 50 0 31.4 0S0 8.8 0 42.6c0 33.7 12.8 42.5 31.4 42.5z",
    fill: "#0082fc",
    fillRule: "evenodd"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    x: 33.1
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A",
    x: 88.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluetooth);
export default __webpack_public_path__ + "static/media/Bluetooth.c87b79d7e799126a43fdf8e495268187.svg";
export { ForwardRef as ReactComponent };